
<template>
  <div class="cntnt">

    <div id="whoweare">
        <br>
        <h1 class="heading"> আমাৰ পৰিচয় </h1>
        <p class="content">
          আমি অসমবাসী লোকসকলৰ সকলো দিশৰ বিকাশৰ লক্ষ্যত উৎসৰ্গিত এক বিশ্বমানৰ প্রতিষ্ঠান।
          আমি আমাৰ উপভোক্তাসকলক সকলো সময়তে (২৪×৭) নিৰৱচ্ছিন্ন, বিশ্বাসযোগ্য, সুৰক্ষিত, সুলভ আৰু মানসম্পন্ন বিদ্যুতৰ যোগান ধৰো।
          আমাৰ সকলো ধৰণৰ সেৱাত উপভোক্তাসকলে ১০০ শতাংশ সন্তুষ্টি লাভ কৰাটো সুনিশ্চিত কৰি আমি উপভোক্তাসকলক তেওঁলোকৰ আশাকৈও বেছি সন্তুষ্টি প্রদান কৰো।
          <br><br>
          আমি আমাৰ সেৱাসমূহ আগবঢ়াওতে পৰিৱেশ-বন্ধু পদ্ধতি আৰু বহনক্ষম উন্নয়ণত যথোচিত গুৰুত্ব দিওঁ।
          আমি সময়োপযোগী প্রতিৰক্ষামূলক আৰু নিৰোধক ৰক্ষণাবেক্ষণৰ কাম সম্পন্ন কৰি আমাৰ আন্তঃগাঁথনিসমূহক সুস্থ-সবল কৰি ৰাখো।
          আমি আমাৰ কামসমূহ কৰোতে আমাৰ নিজৰ বিষয়া-কৰ্মচাৰীসকল, আৰু লগতে আমি সেৱা আগবঢ়োৱা লোকসকল যাতে সুৰক্ষিত
          হৈ থাকে, সেয়া সুনিশ্চিত কৰো। আমাৰ সেৱাসমূহৰ বাবদ হোৱা ব্যয় নিম্নতম কৰিবলৈ আমি সকলো ক্ষেত্রতে অতিশয় মিতব্যয়ী।
          আমাৰ উপভোক্তাসকললৈ মানসম্পন্ন বিদ্যুৎ যোগান অব্যাহত ৰাখিবৰ বাবে আমি আমাৰ বৈদ্যুতিক প্রণালীসমূহ নিৰন্তৰভাবে উন্নীত
          কৰি ৰাখো। আমি আমাৰ প্রকল্পসমূহ সময়মতে সম্পূৰ্ণ কৰি তোলো আৰু লগতে প্রকল্প-ব্যয় কমাবলৈ আৰু কামবোৰৰ মানদণ্ড উন্নত কৰিবলৈ চেষ্টা কৰো।
          অসমৰ বিকাশৰ গতি ত্বৰান্বিত কৰাৰ ক্ষেত্রত আমাৰ সামগ্রী যোগানকাৰী আৰু ঠিকাদাৰসকলো আমাৰ অংশীদাৰ।
          আমাৰ সকলো কামত আমি এক যুক্তিসন্মত লাভহে আৰ্জন কৰিবলৈ চেষ্টা কৰো,
          যাতে আমি আমাৰ উপভোক্তাসকলক মানবিশিষ্ট সেৱা আগবঢ়াবলৈ প্রয়োজনীয় সম্পদ আহৰণ কৰিব পাৰো।
         <br><br>
         আমাৰ সকলো বিষয়া-কৰ্মচাৰীয়ে আটাইতকৈ কঠিন পৰিস্থিতিতো এটা গোট হিচাপে, আৰু তেওঁলোকে সেৱা আগবঢ়োৱা
         লোকসকলৰ প্রতি উৎসৰ্গিতভাবে, কাম কৰি যায়। আমাৰ সেই নিষ্ঠাবান বিষয়া-কৰ্মচাৰীসকলৰ প্রতি আমাৰ নীতি আৰু
         মনোভাৱ অতি মানৱীয় আৰু সহানুভূতিমূলক।
         <br><br>
         আমাৰ বৰ্তমান পৰিচয় এয়াই আৰু আমি ভৱিষ্যতেও এনে হৈ থাকিম।



</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="regoffice">
  <br>
    <h1 class="heading"> পঞ্জীভুক্ত কাৰ্যালয়</h1>
    <p class="content">
      অসম শক্তি বিতৰণ কোম্পানী লিমিটেদ<br>
      ৪ৰ্থ মহলা<br>
      বিজুলী ভৱন<br>
      পল্টন বজাৰ<br>
      গুৱাহাটী – ৭৮১০০১<br>
      অসম – ভাৰত
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>

<div id="profile">
<br>
    <h1 class="heading">  কোম্পানীৰ সংক্ষিপ্ত</h1>
    <p class="content">
      অসম শক্তি বিতৰণ কোম্পানী লিমিটেদ (এ.পি.দি.চি.এল) হৈছে অসম চৰকাৰৰ সম্পূৰ্ণ মালিকানাধীন এক ৰাজহুৱা সীমিত কোম্পানী।
      এই প্ৰতিষ্ঠানক ২০০৯ চনৰ অক্টোবৰৰ ২৩ তাৰিখে অন্তৰ্ভুক্ত কৰা হৈছিল আৰু ভাৰতীয় কোম্পানী আইন ১৯৫৬ ৰ অধীনত পঞ্জীয়ন কৰা হৈছে।
    </p>
      <p class="content">
      অসম শক্তি বিতৰণ কোম্পানী লিমিটেদ (এ.পি.দি.চি.এল) হৈছে অসম চৰকাৰৰ সম্পূৰ্ণ মালিকানাধীন এক ৰাজহুৱা সীমিত কোম্পানী।
      এই প্ৰতিষ্ঠানক ২০০৯ চনৰ অক্টোবৰৰ ২৩ তাৰিখে অন্তৰ্ভুক্ত কৰা হৈছিল আৰু ভাৰতীয় কোম্পানী আইন ১৯৫৬ ৰ অধীনত পঞ্জীয়ন কৰা হৈছে।
     </p>
       <p class="content">
      কোম্পানীটোৰ প্ৰাথমিক উদ্দেশ্য হৈছে প্ৰযোজ্য আইন আৰু ইয়াৰ আনুষঙ্গিক সকলো ব্যৱস্থা অনুসৰি অসম ৰাজ্যত বা ইয়াৰ বাহিৰত
       বিদ্যুতৰ বিতৰণ, ব্যৱসায় আৰু যোগান কৰা।  ইয়াৰ লগতে প্ৰতিষ্ঠানটোৰ অসম ৰাজ্যত বিদ্যুৎ বিতৰণ প্ৰণালীৰ বিকাশ, তদাৰক আৰু পৰিচালনাৰ আদেশ আছে।
      বিদ্যুৎ যোগানৰ কাম সম্পাদন কৰাৰ ক্ষেত্ৰত, এ.পি.ডি.চি.এল. ৰাজ্যৰ প্ৰতিটো প্ৰান্তত উপনীত হৈছে।
       শদিয়াৰ পৰা মানকাচাৰলৈ আৰু জোনাইৰ পৰা লোয়াৰপোৱালৈ। উত্তৰ কাছাৰ পাহাৰৰ পাহাৰীয়া অঞ্চলৰ পৰা মৰিগাঁৱৰ নিম্ন সমভূমিলৈকে,
        এপিডিচিএল-এ বহুতো প্ৰাকৃতিক বাধাকো নেওচি ইয়াৰ বিতৰণ নেটৱৰ্ক সম্প্ৰসাৰিত কৰি আছে।
         চাপাখোৱা উপ-সংমণ্ডলৰ অমৰপুৰ অঞ্চল অথবা ব্ৰহ্মপুত্ৰৰ চৰ অঞ্চলসমূহৰ দৰে বিতৰণ নেটৱৰ্কে ঢুকি নোপোৱা অঞ্চলসমূহত এ.পি.দি.চি.এল-য়ে অফ-গ্ৰিড সৌৰ প্ৰকল্পও ৰূপায়ণ কৰিছে।

    </p>
    <p class="content">
      এপিডিচিএল-এ অসমত অৱস্থিত মুখ্য ঔদ্যোগিক কেন্দ্ৰ যেনে ক’ল ইণ্ডিয়া লিমিটেড (লিডু, মাৰ্ঘেৰিটা),
      ব্ৰহ্মপুত্ৰ গেচ এণ্ড পলিমাৰ লিমিটেদ(লেপেটকাটা, ডিব্ৰুগড়), চিমেণ্ট ক’ৰ্পোৰেচন অফ্‌ ইণ্ডিয়া লিমিটেদ(বোকাজান),
      হিন্দুস্তান পেপাৰ ক’ৰ্পোৰেচন লিমিটেদ(পঞ্চগ্ৰাম আৰু জাগীৰোড্‌), অসম পেট্ৰ’কেমিকেলচ লিমিটেদ(নামৰূপ) ইত্যাদিলৈ বিদ্যুৎ যোগান ধৰিছে
      আৰু ৬৪ লাখতকৈ অধিক উপভোক্তা আধাৰ থকা অসমৰ জনসাধাৰণক সেৱা আগবঢ়াই আছে আৰু এই সংখ্যা প্ৰতি বছৰে বৃদ্ধি পাই আছে।

       <!-- <br><br>
      <b-table striped hover :items="ScaleOp">
        <template v-slot:cell(Name)="data" >
          <span  v-html="data.value"></span>
        </template>
      </b-table>  -->
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>
<div id="glance">
  <br>
    <h1 class="heading">চকুৰ পচাৰতে এপিদিচিএল <span style="color:#616161   !important;font-size:1rem">(০১/০৫/২০২১ তাৰিখত)</span></h1>
    <p class="content">
      <ul class="a">
        <!-- <li><strong>Area :</strong> 70,000 sq. kms / 26395 villages / 214 towns</li>-->
        <li><strong>সৰ্বমুঠ উপভোক্তা  :</strong> ৬৪ লাখ</li>
        <li><strong>সৰ্বমুঠ এম.ইউ. যোগান :</strong>	৭১০৮ এম.ইউ. (বৃত্তীয় বৰ্ষ ১৯-২০)</li>
        <li><strong>৩৩/১১ কে.ভি. বৈদ্যুতিক উপ-আস্থানৰ মুঠ সংখ্যা :</strong>	৫১০ <span style="font-size:0.8rem"> (তালিকা দাউনলোদ কৰক :	<a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_LAR.pdf" target="_blank">এল.এ.আৰ.</a> | <a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_CAR.pdf" target="_blank">চি.এ.আৰ.</a> | <a href="https://www.apdcl.org/website/docs/documents/Sub_Stations_UAR.pdf" target="_blank">ইউ.এ.আৰ.</a>)</span></li>
        <!-- <li><strong>Total Capacity of sub stations :</strong>	MVA</li> -->
        <li><strong>৩৩ কে.ভি. বৈদ্যুতিক লাইনৰ মুঠ দৈৰ্ঘ্য :</strong> ৯৬২৮.২৮ কি মি</li>
        <li><strong>১১ কে.ভি. বৈদ্যুতিক লাইনৰ মুঠ দৈৰ্ঘ্য  :</strong>	৯৫২৯৯.৪১ কি মি</li>
        <li><strong>এল.টি. বৈদ্যুতিক লাইনৰ মুঠ দৈৰ্ঘ্য(3-Phase) :</strong>	১৫৮১২৪.৭১ কি মি</li>
        <li><strong>এল.টি. বৈদ্যুতিক লাইনৰ মুঠ দৈৰ্ঘ্য (1-Phase)	 :</strong>	১৭২৭৩৮.১০ কি মি</li>
        <li><strong>১১ কে ভি ফিদাৰৰ মুঠ সংখ্যা :</strong>	১৭৬৫</li>
        <li><strong>বিতৰণ ট্ৰেন্সফ’ৰ্মাৰৰ মুঠ সংখ্যা :</strong> ১১৪৩২০</li>
        <li><strong>মুঠ প্ৰি-পেইদ্‌ মিটাৰ :</strong> ৫৫১৩</li>
        <!-- <li><strong>Total Capacity of Distribution Transforms :</strong>	 MVA</li>
        <li><strong>Annual Revenue (2019-20) :</strong> (₹ in Crores)	</li>
        <li><strong>Annual Expenses(2019-20) :</strong> (₹ in Crores)	</li> -->
        <li><strong>প্ৰশাসনীয় গাঁথনি :</strong>	৩ সংখ্যক বৈদ্যুতিক অঞ্চল, ৮ সংখ্যক বৈদ্যুতিক মণ্ডল,
          ১৯ সংখ্যক বৈদ্যুতিক চক্ৰ, ৪৫ সংখ্যক বৈদ্যুতিক সংমণ্ডল, ১৫৮ সংখ্যক বৈদ্যুতিক উপ-সংমণ্ডল</li>
        <!-- <li><strong>Employee Strength :</strong></li> -->
      </ul>
  </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>

<div id="Mandate">
  <br>
    <h1 class="heading">কোম্পানীৰ আদেশ</h1>
    <p class="content">
      অসম শক্তি বিতৰণ কোম্পানী লিমিটেদ – এই কোম্পানীটো ২০০৯ চনৰ অক্টোবৰৰ ২৩ তাৰিখে অসম চৰকাৰৰ সম্পূৰ্ণ মালিকানাধীন ৰাজহুৱা
      সীমিত কোম্পানী হিচাপে অন্তৰ্ভুক্ত কৰা হৈছিল। কোম্পানীটোৰ চূড়ান্ত উদ্দেশ্য হৈছে প্ৰযোজ্য আইন আৰু ইয়াৰ আনুষঙ্গিক সকলো ব্যৱস্থা অনুসৰি
      অসম ৰাজ্যত বা ইয়াৰ বাহিৰত বিদ্যুতৰ বিতৰণ, ব্যৱসায় আৰু যোগান কৰা।
      <br><br>
      এই কোম্পানী গঠনৰ মুখ্য উদ্দেশ্য আছিল বিদ্যুৎ আইন, ২০০৩-ৰ ত্ৰয়োদশ খণ্ডৰ অন্তৰ্গত অধিসূচিত স্থানান্তৰ আঁচনি অনুসৰি পূৰ্বৰ
      অসম ৰাজ্যিক বিদ্যুৎ পৰিষদৰ (এএছইবি)-ৰ বিদ্যুৎ বিতৰণ প্ৰণালী, সম্পত্তি ও দায়বদ্ধতাৰ অধিগ্ৰহণ, কাৰ্যকৰীকৰণ আৰু পৰিচালনা কৰা।
      পৰৱৰ্তী সময়ত, বিদ্যুৎ আইন, ২০০৩ ৰ অধীনত অসম চৰকাৰে  এ.এছ.ই.বি.-ৰ বিভিন্ন সম্পত্তি, দায়বদ্ধতা আদি PEL. 151/2003/Pt./165
      dated 10th December, 2004 নং গেজেট অধিসূচনা যোগে অস্থায়ীভাৱে আৰু PEL. 151/2003/Pt./349 dated Dispur, the 16th August,
      2005 গেজেট অধিসূচনা যোগে চূড়ান্তভাৱে কোম্পানীলৈ স্থানান্তৰ কৰাৰ জাননী প্ৰদান কৰে।
      <br><br>
      কোম্পানীৰ মূল লক্ষ্য হৈছে অসম ৰাজ্যত বিদ্যুত বিতৰণ প্ৰণালীৰ বিকাশ, তদাৰক আৰু পৰিচালন কৰা।
  </p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="vision">
  <br>
    <h1 class="heading">আমাৰ ভৱিষ্যদৰ্শন </h1>
    <p class="content">

    " অসমৰ সৰ্বাঙ্গীন উন্নতিত সৰ্বতোপ্ৰকাৰে সহায় কৰিবলৈ অসমৰ কৃষিখণ্ড আৰু উদ্যোগসমূহত মানসম্পন্ন বিদ্যুৎ যোগান ধৰা;
    অসমৰ গাওঁ, নগৰ-মহানগৰত বাস কৰা সকলো লোকৰে ঘৰত বিদ্যুতৰ বিতৰণ কৰা আৰু লগতে আভ্যন্তৰীণ সম্পদ আহৰণ কৰি প্রযুক্তিবিদ্যা
    আৰু যোগান পদ্ধতিৰ নিৰলস বিকাশ ঘটাই সন্মানীয় গ্রাহকসকলক তেওঁলোকে আশা কৰাতকৈও বেছি সন্তুষ্টি প্রদান কৰা। "
    </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>

<div id="mission">
    <br>
    <h1 class="heading">আমাৰ লক্ষ্য</h1>
    <p class="content">

আমাৰ লক্ষ্য হ’ল অসম শক্তি বিতৰণ কোম্পানী লিমিটেডক (এ পি ডি চি এল) সমগ্র অসমে গৌৰৱ কৰিব পৰা এক প্রতিষ্ঠান হিচাপে গঢ়ি তোলা।
আমি বিশ্বাস কৰো যে তলত উল্লেখ কৰা ১৫ টা আঁচনিৰ সফল ৰূপায়নে আমাৰ লক্ষ্যক (Mission) বাস্তৱায়িত কৰাত সহায় কৰিব।
<ul class="a" style="padding-left:40px ">
<li> আমাৰ গ্রাহকসকলৰ সময়সাপেক্ষ চাহিদা পূৰণ কৰিবৰ বাবে আগতীয়া পৰিকল্পনাৰে প্রয়োজনীয় বিদ্যুৎ শক্তি ক্রয় কৰি বা আন প্রকাৰে যোগাৰ কৰি ৰখা।</li>
<li> আন্তঃগাঁথনি উন্নয়নত বিনিয়োগ কৰি বৈদ্যুতিক উপ-সংমণ্ডল আৰু বিতৰণ নেটৱৰ্ক উপযুক্তভাবে শক্তিশালী কৰি তোলা।  </li>
<li> আমাৰ বিতৰণ নেটৱৰ্কৰ প্রসাৰ ঘটাই অসমৰ সকলো গাওঁ-নগৰত পৰ্যাপ্ত বিদ্যুৎ যোগানৰ ব্যৱস্থা কৰা।</li>
<li> বিজুলী শক্তিৰ মিতব্যয়ী ব্যৱহাৰ সম্পৰ্কত গ্রাহকসকলৰ মাজত সজাগতা বৃদ্ধি কৰা।</li>
<li> ইলেক্ট্র-মেকানিকেল মিটাৰসমূহ সলনি কৰি সেইবোৰৰ ঠাইত ইলেক্ট্রনিক মিটাৰ স্থাপন কৰা।৷</li>
<li> ১০০ শতাংশ ৰাজহ আহৰণ, এনাৰ্জি অডিট (Energy Audit) আৰু গ্রাহকে সঠিক বিল পোৱাৰ ব্যৱস্থা কৰা। </li>
<li> প্রয়োজন সাপেক্ষে ফ্ৰেনচাইজি (Franchisee) নিযুক্তিকৰণৰ দ্বাৰা গ্ৰাহকসকললৈ উন্নততৰ সেৱা আগবঢ়োৱাৰ ব্যৱস্থা কৰা।  </li>
<li> অকৰ্তৃত্বশীলভাবে বিদ্যুৎ ব্যৱহাৰ কৰাসকলক চিনাক্তকৰণ কৰি শাস্তিমূলক ব্যৱস্থা গ্রহণ কৰিবলৈ তদাৰকী কোষ (Vigilance Cell) গঠন কৰা। </li>
<li> এ পি ডি চি এল-ৰ বিষয়া-কৰ্মচাৰীসকলক অধিক গ্রাহক-বন্ধু হিচাপে গঢ়ি তুলিবলৈ উপযুক্ত প্রশিক্ষণৰ ব্যৱস্থা কৰা।</li>
<li> গ্রাহকৰ সুবিধাৰ বাবে অত্যাধুনিক গ্রাহক সেৱা কেন্দ্র গঢ়ি তোলা আৰু গ্রাহক সূচীকৰণ (Consumer Indexing) কাম সম্পূৰ্ণ কৰা।</li>
<li> এ পি ডি চি এল-ত সুদৃঢ় বিত্তীয় অনুশাসন গঢ়ি তোলা। </li>
<li> বিদ্যুৎ গ্রাহকসকলৰ মনত এ পি ডি চি এল সম্পৰ্কত বিশ্বাস আৰু আস্থা গঢ়ি তোলা। </li>
<li> HT/LT অনুপাত সঠিক হিচাপত ৰাখিবলৈ মাষ্টাৰ প্লেন তৈয়াৰ কৰি তাক কাৰ্যকৰী কৰা। </li>
<li> ছিংগল ফেজ লাইনক অধিক ফেজৰ লাইনলৈ পৰিবৰ্তন কৰি এ টি এণ্ড চি ক্ষতি (AT&C Loss) হ্ৰাস কৰা।</li>
<li> পৰিবাহীৰ ক্ষেত্রত অ'ভাৰহেড লাইনৰ সলনি ভূমিতলীয় কেবল (Underground Cable) বহুওৱা।</li>
</ul>
</p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>

<!--<div id="minister">
    <br>
    <h1 class="heading">মন্ত্ৰী</h1>

  <h4 class="content"> শ্ৰীমতী নন্দিতা গাৰ্লোছা </h4><br>
  <p class="content">  মাননীয় শক্তি মন্ত্ৰী, অসম<br>
     ডি ব্লক, চতুৰ্থ মহলা<br> 
    জনতা ভৱন, দিছপুৰ<br>
    গুৱাহাটী - ৭৮১০০৬<br>
     ফোন নং: ০৩৬১-২২৩৭২৬৭<br> 
</p>
</div>-->

<br><br><br><br><br><br><br><br><br><br><br>
<div id="bod">
    <br>
  <h1 class="heading">সঞ্চালক মণ্ডলী</h1>
  <p class="content">

  <!-- <ol class="bod_class">
      <li>  শ্ৰী জিষ্ণু বৰুৱা, আই.এ.এছ., অধ্যক্ষ, এপিডিচিএল, বিজুলী ভৱন, পল্টনবজাৰ, গুৱাহাটী - ৭৮১০০৬ </li>
      <li>  শ্ৰী এছ কে সিনহা, আই.এ.এছ., প্ৰধান সচিব, বিত্ত বিভাগ , দিছপুৰ, গুৱাহাটী - ৭৮১০০৬ </li>
      <li>  শ্ৰী নিৰজ বাৰ্মা, আই.এ.এছ., প্ৰধান সচিব, শক্তি বিভাগ, দিছপুৰ, গুৱাহাটী - ৭৮১০০৬</li>

      <li>  শ্ৰী ৰাকেশ কুমাৰ, আই.এ.এছ., পৰিচালন সঞ্চালক, এপিডিচিএল, বিজুলী ভৱন, পল্টনবজাৰ, গুৱাহাটী - ৭৮১০০৬</li>

      <li>  ড. প্ৰদীপ ঠাকুৰীয়া, স্বৰাজ ৰেচিডেন্সি, ব্লক-এ ৬(বি), গণেশগুৰি, হেংগেৰাবাৰী ৰোড, দিছপুৰ, গুৱাহাটী - ৭৮১০০৬</li>
      <li>  শ্ৰী তৰুণ বৰুৱা মৰাণ, চাংমাইগাঁও, ডাকঘৰ- শুকানপুখুৰী, তিনিচুকীয়া - ৭৮৬১৪৬</li>
  </ol> -->
  <b-table style= "text-align:left" responsive :items="getBoardDirector" :fields="BoardDirectorFields"></b-table>
    </p>
</div>

<!-- <br><br><br><br><br><br><br><br><br><br><br>

<div id="chairmsg">
    <h1 class="heading">Chairman's Message</h1>

  <h4 class="content">Shri Vinod Kumar Pipersenia, IAS (Retd.)</h4>
<p class="content">  Chairman, APDCL</p>
<p class="content">
  <br>

</p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<div id="mdmsg">
    <h1 class="heading">MD's Message</h1>

  <h4 class="content">Shri Rakesh Agarwala, IAS</h4>
  <p class="content">Managing Director, APDCL</p>
<p class="content">
  All of you are aware of the difficult time faced by the Company in wake of COVID-19.
   Being an essential service, we are obligated to ensure proper supply.
   Poor collection vis-à-vis heavy fixed cost requirement like power purchase,
   pay & allowances, R&M etc. has led to accumulation of dues against various agencies
   supplying power to the tune of Rs. 1250 Crore. With no respite in payment obligation there is
   every likelihood of non-scheduling of power in the eventuality of non-payment of dues in time.
   It needs no mention that such a precarious situation will only add to worse.
   On perusal of records, it is observed that many high valued consumers are being allowed to enjoy
   the service even after non-payment for a prolonged period of time. Such act of leniency is very
   unbecoming on part of senior level officials.
   In view of the aforementioned, it is urged upon all to pull the s ocks and take all measures
   within the ambit of law to ensure maximum collection emphasizing on arrear prior to April, 2020.
   It needs no mention that inadequate collection may lead to non-payment of Salary and thereby
   disenchantment amongst the workforce discharging 24x7 non-stop duties even in these difficult hours.
</p>
</div> -->

<br><br><br><br><br><br><br><br><br><br><br>


<div id="jobchart">
    <br>
    <h1 class="heading">চাকৰিৰ চনদ আৰু মূল বিষয়াবৃন্দৰ দায়িত্ব</h1>
    <b-table style= "text-align:left" responsive striped :items="getJobResponsibility" :fields="Jobfields"></b-table>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<div id="adminh">
    <br>
    <h1 class="heading">প্ৰশাসনীয় বৰ্গীকৰণ</h1>
    <p class="content">
      কোম্পানীটোৰ মুখ্য কাৰ্যালয়ত নিম্নলিখিত শাখাবোৰ আছে যিয়ে অধ্যক্ষ আৰু পৰিচালনা সঞ্চালকৰ প্ৰশাসনিক নিয়ন্ত্ৰণ আৰু তত্বাৱধানত কাম কৰে।
      <ol>
        <li>কাৰিকৰী শাখাৰ নেতৃত্ব চিজিএম (ডি এণ্ড এছ), এলএআৰ, চিএআৰ, ইউএআৰ দ্বাৰা কৰা হয়</li>
        <li>সামগ্ৰী ব্যৱস্থাপনা, প্ৰকল্প পৰিকল্পনা আৰু ডিজাইন শাখাৰ নেতৃত্ব চিজিএম (পিপি এণ্ড ডি)ৰ দ্বাৰা কৰা হয়</li>
        <li>গ্ৰাম্য বৈদ্যুতিকৰণ শাখাৰ নেতৃত্ব চিজিএম (আৰই)ৰ দ্বাৰা কৰা হয়</li>
        <li>বাণিজ্যিক ৰাজহ, বাণিজ্যিক শুল্ক আৰু শক্তি দক্ষতা শাখাৰ নেতৃত্ব চিজিএম (কম. আৰু ই.ই.)ৰ দ্বাৰা কৰা হয়</li>
        <li>গ্ৰাহক সম্পৰ্ক, বিপণন আৰু সুৰক্ষা শাখাৰ নেতৃত্ব চিজিএম (চিআৰ, মাৰ্কেটিং আৰু সুৰক্ষা)ৰ দ্বাৰা কৰা হয়</li>
        <li>মানৱ সম্পদ উন্নয়ন শাখাৰ নেতৃত্ব চিজিএম (এইচআৰএ)ৰ দ্বাৰা কৰা হয়</li>
        <li>বিত্ত আৰু একাউণ্ট শাখাৰ নেতৃত্ব চিজিএম (এফ এণ্ড এ)ৰ দ্বাৰা কৰা হয়</li>
        <li>প্ৰকল্প ব্যৱস্থাপনা শাখাৰ নেতৃত্ব সঞ্চালক (পিএমইউ)ৰ দ্বাৰা কৰা হয়</li>
        <li>সতৰ্কতা আৰু সুৰক্ষা শাখাৰ নেতৃত্ব চিজিএম (চুৰি বিৰোধী আৰু সুৰক্ষা)ৰ দ্বাৰা কৰা হয়</li>
        <li>চিকিৎসা শাখাৰ নেতৃত্ব মুখ্য চিকিৎসা বিষয়া (চিএমঅ')ৰ দ্বাৰা কৰা হয়</li>
      </ol>
 গ্ৰাহকসকলৰ ওচৰলৈ অধিক সামগ্ৰিক ভাৱে যোগাযোগ কৰাৰ বাবে, কোম্পানীয়ে ইয়াৰ বিদ্যুৎ বিতৰণ কাৰ্যক চিজিএম(ডি এণ্ড এছ)ৰ নেতৃত্বত তিনিটা অঞ্চলত বিভক্ত কৰিছে।
 <ol>
   <li>নিম্ন অসম অঞ্চল (এলএআৰ)</li>
   <li>মধ্য অসম অঞ্চল (চিএআৰ)</li>
   <li>উজনি অসম অঞ্চল (ইউএআৰ)</li>
</ol>
 এই অঞ্চলবোৰক আৰু ৮ টা (আঠটা) অঞ্চলত বিভক্ত কৰা হৈছে আৰু প্ৰতিটো অঞ্চলৰ নেতৃত্ব এজন জেনেৰেল মেনেজাৰ (জিএম)ৰ দ্বাৰা কৰা হৈছে।
<ol>
    <li>এল.এ.আৰ. ৰ অধীনত গুৱাহাটী জ'ন</li>
    <li>এল.এ.আৰ. ৰ অধীনত ৰঙিয়া জ'ন</li>
    <li>এল.এ.আৰ. ৰ অধীনত বঙাইগাঁও জ'ন</li>
    <li>চি.এ.আৰ. ৰ অধীনত নগাঁও জ'ন</li>
    <li>চি.এ.আৰ. ৰ অধীনত তেজপুৰ জ'ন</li>
    <li>চি.এ.আৰ. ৰ অধীনত শিলচৰ জ'ন</li>
    <li>ইউএআৰৰ অধীনত যোৰহাট জ'ন</li>
    <li>ইউএআৰৰ অধীনত ডিব্ৰুগড় জ'ন</li>
  </ol>

 এই ৮ টা (আঠটা) অঞ্চলক আৰু ১৯ (ঊনৈছ) টা চক্ৰত বিভক্ত কৰা হৈছে
 আৰু প্ৰতিটো চক্ৰৰ নেতৃত্ব এজন মুখ্য কাৰ্যবাহী বিষয়া (চিইঅ')ৰ দ্বাৰা ডিজিএম (উপ মহাপ্ৰৱন্ধক) পদবীত দিয়া হৈছে।
<ol>
  <li>গুৱাহাটী জ'নৰ অন্তৰ্গত গুৱাহাটী বৈদ্যুতিক চক্ৰ - ১</li>
  <li>গুৱাহাটী জ'নৰ অন্তৰ্গত গুৱাহাটী বৈদ্যুতিক চক্ৰ - ২</li>
  <li>ৰঙিয়া জ'নৰ অন্তৰ্গত ৰঙিয়া বৈদ্যুতিক চক্ৰ</li>
  <li>ৰঙিয়া জ'নৰ অন্তৰ্গত মঙলদৈ বৈদ্যুতিক চক্ৰ</li>
  <li>বঙাইগাঁও জ'নৰ অন্তৰ্গত বঙাইগাঁও বৈদ্যুতিক চক্ৰ</li>
  <li>বঙাইগাঁও জ'নৰ অন্তৰ্গত কোকৰাঝাৰ বৈদ্যুতিক চক্ৰ</li>
  <li>বঙাইগাঁও জ'নৰ অন্তৰ্গত বৰপেটা বৈদ্যুতিক চক্ৰ</li>
  <li>নগাঁও জ'নৰ অন্তৰ্গত নগাঁও বৈদ্যুতিক চক্ৰ</li>
  <li>নগাঁও জ'নৰ অন্তৰ্গত মৰিগাঁও বৈদ্যুতিক চক্ৰ</li>
  <li>নগাঁও জ'নৰ অন্তৰ্গত কাঞ্চ বৈদ্যুতিক চক্ৰ</li>
  <li>তেজপুৰ জ'নৰ অন্তৰ্গত তেজপুৰ বৈদ্যুতিক চক্ৰ</li>
  <li>তেজপুৰ জ'নৰ অন্তৰ্গত উত্তৰ লখিমপুৰ বৈদ্যুতিক চক্ৰ</li>
  <li>শিলচৰ জ'নৰ অন্তৰ্গত কাছাৰ বৈদ্যুতিক চক্ৰ</li>
  <li>শিলচৰ জ'নৰ অন্তৰ্গত বদৰপুৰ বৈদ্যুতিক চক্ৰ</li>
  <li>যোৰহাট জ'নৰ অন্তৰ্গত যোৰহাট বৈদ্যুতিক চক্ৰ</li>
  <li>যোৰহাট জ'নৰ অন্তৰ্গত গোলাঘাট বৈদ্যুতিক চক্ৰ</li>
  <li>যোৰহাট জ'নৰ অন্তৰ্গত শিৱসাগৰ বৈদ্যুতিক চক্ৰ</li>
  <li>ডিব্ৰুগড় জ'নৰ অন্তৰ্গত ডিব্ৰুগড় বৈদ্যুতিক চক্ৰ</li>
  <li>ডিব্ৰুগড় জ'নৰ অন্তৰ্গত তিনিচুকীয়া বৈদ্যুতিক চক্ৰ</li>
</ol>

প্ৰতিটো চক্ৰক আগলৈ বৈদ্যুতিক বিভাগত বিভক্ত কৰা হৈছে। এপিডিচিএলৰ অধীনত মুঠ ৪৫ টা (পঞ্চল্লিছ) বৈদ্যুতিক বিভাগ আছে।
বিভাগবোৰৰ নেতৃত্ব এজন সহকাৰী মহাপ্ৰৱন্ধক (এজিএম)ৰ দ্বাৰা কৰা হৈছে।
<br><br>
প্ৰতিটো বিভাগক আগলৈ বৈদ্যুতিক উপ-বিভাগত বিভক্ত কৰা হৈছে। এপিডিচিএলৰ অধীনত মুঠ ১৫৮ টা (এশ আঠাৱন্ন) বৈদ্যুতিক উপ-বিভাগ আছে।
উপ-বিভাগবোৰৰ নেতৃত্ব দিছে উপ-বিভাগীয় অভিযন্তাই (এছ.ডি.ই.) এজন উপ-প্ৰৱন্ধক (ডি.এম.) / সহকাৰী প্ৰৱন্ধক (এ.এম.) পদবীত।
<br><br>
লগতে ঔদ্যোগিক গ্ৰাহকসকলৰ প্ৰয়োজনীয়তা সঠিকভাৱে পূৰণ কৰাৰ বাবে,
সমগ্ৰ অসমত ১৭ টা (সোতৰ) আইআৰচিএ (ঔদ্যোগিক ৰাজহ সংগ্ৰহ ক্ষেত্ৰ) স্থাপন কৰা হৈছে,
প্ৰতিটো আইআৰচিএ এজন এৰিয়া মেনেজাৰৰ দ্বাৰা পৰিচালিত হৈছে।

<br><br>
 উপ-বিভাগ আৰু আইআৰচিএসমূহ হৈছে এপিডিচিএলৰ মুখ্য ৰাজহ গোট।
<br><br>
    </p>
</div>

<br><br><br><br><br><br><br><br><br><br><br>
<!-- <div id="scaleop">
    <h1 class="heading">Scale of Operations</h1>

</div> -->

<br><br><br><br><br><br><br><br><br><br><br>
<div id="gmap">
    <br>
    <h1 class="heading">ভৌগোলিক মানচিত্ৰ</h1>
    <p class="content">
      <b-img src="../assets/gmap.jpg" style="width:75%"/>
    </p>
</div>

<br><br><br><br><br><br><br><br><br><br><br><br><br><br>
<div id="pmap">
    <br>
    <h1 class="heading">শক্তি মানচিত্ৰ</h1>
    <p class="content">
      <b-img src="../assets/pmap.jpg" style="width:75%" />
    </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 0rem;
   text-transform: uppercase;

}
.content{
    text-align: justify;
line-height: 1.8rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
ul.a {
  list-style-type: circle;
}
@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .content{
    margin-right: 60px;
  }
  }

  @media (max-width: 576px) {
    .marginTop-250px{
      margin-top: -250px;
    }
  }
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {

data() {
  return {

    ScaleOp: [
      { Name: 'No. of 33/11 kV Sub-Stations (<span style="font-size:0.8rem"> Download List:	<a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_LAR.pdf" target="_blank">এল.এ.আৰ.</a> | <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_CAR.pdf" target="_blank">চি.এ.আৰ.</a> | <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sub_Stations_UAR.pdf" target="_blank">UAR</a></span>)', Quantity: '347 Nos'},
      { Name: 'Total Capacity of the Sub-Stations	', Quantity: '3016.81 MVA'},
      { Name: 'Total length of 33 KV Lines	', Quantity: '5995.88 KMs'},
      { Name: 'Total length of 11 KV Lines	', Quantity: '54706.13 KMs'},
      { Name: 'Total length of LT Lines (3-Phase)	', Quantity: '45013.13 KMs'},
      { Name: 'Total length of LT Lines (1-Phase)	', Quantity: '98670.77 KMs'},
      { Name: 'Total number of Distribution Transformers	', Quantity: '64493 Nos'},
      { Name: 'Total Capacity of Distribution Transformers	', Quantity: '4484.31 MVA'},
    ],
      Jobfields: [
          { key: 'contact_person', label: 'নাম',thStyle: {width: '20vw'} },
          { key: 'designation', label: 'পদবী',thStyle: {width: '20vw'} },
          { key: 'job_allocation', label: 'চাকৰিৰ দায়িত্ব',thStyle: {width: '40vw'} }
        ],
        BoardDirectorFields: [
          { key: 'desc', label: 'কোম্পানীৰ মাননীয় সঞ্চালকসকল:' }

          ]

  }
},
computed:
{
  ...mapGetters([
    'getJobResponsibility',
    'getBoardDirector'
  ])
},
methods: {
  ...mapActions([
    'retrieveAboutContact'
  ])
},
beforeMount() {
    if(this.getJobResponsibility.length == 0) {
      this.retrieveAboutContact()
    }
}
}
</script>
<style scoped="true">
@font-face {
  font-family: Custom_Assamese_Font;
  src: url("../assets/Assamese_font/Asomiya_Rohini.ttf");
}
.bod_class
{
  font-family:Custom_Assamese_Font !important;
}
</style>
